module.exports = __webpack_public_path__ + "static/media/keegan-jervis-resume-2022.34ef6d48.pdf";